import { useContext } from "react";
import DataClientContext from "./DataClientContext";
export default function useGraphQlDataClient() {
    const dataClient = useContext(DataClientContext);
    if (!('graphQlDataClient' in dataClient) || !dataClient.graphQlDataClient) {
        throw new Error('@sail/data revamp GraphQL API has been used without it being initialized. Please check that you are rendering DataProvider with unstable_sail_data_revamp.graphql property set.');
    }
    return dataClient.graphQlDataClient;
}

//# sourceMappingURL=useGraphQlDataClient.js.map